import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
  name: 'currencyDisplay'
})
export class CurrencyDisplayPipe implements PipeTransform {
  transform(value: number | string | null | undefined): string {
    if (value === null || value === undefined || value === '' || isNaN(Number(value))) {
      return '0.00';
    }
    
    const numValue = Number(value);
    
    // Force exactly 2 decimal places
    return numValue.toFixed(2);
  }
}